// Copyright (c) 2017 Deere & Company

import React, {Component, PropTypes} from 'react';
import CheckboxWithSearchFilterControlled from '../../../../shared/components/facets/checkbox-with-search-filter/controlled';
import FacetFooter from '../../../../shared/components/facets/facet-footer/index';
import Facets from '../../state/facets';
import RadioButtonFilterControlled from '../../../../shared/components/facets/radio-button-filter/controlled';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';
import {isDealerFacetInvalid} from '../../../../shared/services/facets';

function handleDealerAccountFacetItem(item, isSelected) {

    this.props.actions.updateDealerAccountFacetItem(item, isSelected);

}

function handleDealerFilterInput(text) {

    this.props.actions.updateDealerAccountFacetInput(text);

}

function toggleDealerAccountFacetItems() {

    this.props.actions.toggleDealerAccountFacetItems(this.props.facets.dealerAccountsFacet.allowedDealers);

}

function handleShowExcludedFacetItem(index) {

    this.actions.updateShowExcludedFacetItem(this.facets.showExcludedFacet.allowedExcluded[index]);

}

function handleApplyFilters() {

    if (!isDealerFacetInvalid(this.props.facets.dealerAccountsFacet)) {

        this.props.actions.readLaborAdditivePipProducts(this.props.facets);

    }

}

function handleResetFilters() {

    this.props.actions.resetAllFacets(
        this.props.facets.dealerAccountsFacet.allowedDealers,
        this.props.facets.showExcludedFacet.allowedExcluded
    );

}

const loadAllDealers = dealerAccountsFacet => dealerAccountsFacet.isInitialLoad || dealerAccountsFacet.selectedDealers.length === 0;

class LaborAdditiveFacets extends Component {

    state = {
        dealerLocationExpanded: false,
        showExcludedExpanded: false
    };

    componentWillMount() {

        if (loadAllDealers(this.props.facets.dealerAccountsFacet)) {

            this.props.actions.initializeDealerAccountFacetItems(this.props.facets.dealerAccountsFacet.allowedDealers);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetAllFacets(
            this.props.facets.dealerAccountsFacet.allowedDealers,
            this.props.facets.showExcludedFacet.allowedExcluded
        );

    }

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.showExcludedExpanded || this.state.dealerLocationExpanded;

    render() {

        return (
            <aside className='open-pips-facets'>
                <CheckboxWithSearchFilterControlled
                    initialState={createHashMap(this.props.facets.dealerAccountsFacet.selectedDealers, 'account')}
                    isExpanded={this.state.dealerLocationExpanded}
                    list={addCollectionLabels(this.props.facets.dealerAccountsFacet.displayedDealers)}
                    minNumberOfItems={4}
                    onCheckboxListChange={this::handleDealerAccountFacetItem}
                    onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                    onInputChange={this::handleDealerFilterInput}
                    onToggleAll={this::toggleDealerAccountFacetItems}
                    searchInput={this.props.facets.dealerAccountsFacet.searchInput}
                    searchPlaceholder='DEALER_LOCATION_FILTER'
                    title='DEALER_LOCATIONS'
                    valueKey={'account'}
                />
                <RadioButtonFilterControlled
                    isExpanded={this.state.showExcludedExpanded}
                    list={this.props.facets.showExcludedFacet.allowedExcluded}
                    onClick={this.onAccordionToggle.bind(this, 'showExcludedExpanded')}
                    onItemUpdate={this.props::handleShowExcludedFacetItem}
                    selectedItem={this.props.facets.showExcludedFacet.selectedExcluded}
                    title={'SHOW_EXCLUDED'}
                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={isDealerFacetInvalid(this.props.facets.dealerAccountsFacet)}
                        onApply={this::handleApplyFilters}
                        onReset={this::handleResetFilters}
                    /> : null}
            </aside>
        );

    }

}

LaborAdditiveFacets.displayName = 'LaborAdditiveFacets';
LaborAdditiveFacets.propTypes = {
    actions: PropTypes.object.isRequired,
    facets: PropTypes.instanceOf(Facets)
};

export default LaborAdditiveFacets;



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/labor-additive-pips-aside/labor-additive-facets.js